import React from 'react';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-white bg-opacity-90">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-[var(--darkBlue)]"></div>
      <p className="mt-4 text-[var(--darkBlue)] font-medium">{message}</p>
    </div>
  );
};

export default LoadingSpinner;